<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'total_imports_exports_1pmc',
    components: {
      VuePlotly,
    },
    props: [],
    computed: {
      ...mapGetters([
        'get_dsm_result',
        'historyPlotDataTotal',
        'getDsmAppState',
        'app_data',
        'single_product',
        'home_market_code',
      ]),

      plotData: function () {
        let plot_list = [
          {
            y: this.array_value_conversion(
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
                'dsm_history_total_world_sum'
              ].map(v => v['HM_ExportVal']),
              'time_weighted',
            ),
            x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
              'dsm_history_sum'
            ].map(v => v['T_Year']),
            name: `${this.codeToMarket(this.home_market_code)} exports of ${
              this.single_product
            } to World`,
            mode: 'lines',
            line: {
              color: config.plot_blue,
              width: config.plot_line_width,
              dash: 'solid',
            },
          },

          {
            y: this.array_value_conversion(
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
                'dsm_history_total_world_sum'
              ].map(v => v['HM_ImportVal']),
              'time_weighted',
            ),
            x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
              'dsm_history_sum'
            ].map(v => v['T_Year']),
            name: `${this.codeToMarket(this.home_market_code)} imports of ${
              this.single_product
            } from World`,
            mode: 'lines',
            line: {
              color: config.plot_red,
              width: config.plot_line_width,
              dash: 'solid',
            },
          },
        ];

        // Add provincial share if this is a provincial model
        let prov_share = null;
        if (this.$store.state.app.selectedModelName !== 'National') {
          prov_share = {
            y: this.array_value_conversion(
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
                'dsm_history_total_world_sum'
              ].map(v => v['HM_ExportVal']),
              'time_weighted',
            ).map(
              v =>
                v *
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .query_results['TW_Share_Prov'],
            ),
            x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
              'dsm_history_sum'
            ].map(v => v['T_Year']),
            name:
              this.$store.state.app.selectedModelName +
              ' export share (' +
              (
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .query_results['TW_Share_Prov'] * 100
              ).toFixed(2) +
              '%) of ' +
              this.single_product +
              ' total exports',
            mode: 'lines',
            line: {
              color: config.plot_green,
              width: config.plot_line_width,
              dash: 'dashdot',
            },
          };
          // add the line to the second position (1) and remove 0
          if (this.$store.state.app.selectedModelName.length > 0) {
            plot_list.splice(1, 0, prov_share);
          }
        }

        return plot_list;
      },
      show: function () {
        // return this.$store.getters.historyPlotDataTotal['x'][0] > 1 ? true : false;
        return true;
      },
      layout: function () {
        return {
          title: {
            automargin: true,
            text:
              'Total imports and exports of ' +
              this.single_product +
              ' <br>' +
              'into and from ' +
              this.codeToMarket(this.home_market_code) +" ("+ this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.markets_count+ " selected markets)",
            font: {
              size: 10,
              color: 'black',
            },
            yref: 'container',
            x: 0.1,
            y: 0.94,
            yanchor: 'bottom',
            pad: {
              b: 10,
            },
          },
          height: '300',
          width: '350',
          autosize: true,
          margin: {
            l: 50,
            r: 20,
            b: 80,
            t: 55,
            pad: 2,
          },

          xaxis: {
            tickmode: 'linear',
            fixedrange: true,
            tickfont: {
              size: 10,
            },
          },
          yaxis: {
            title: '',
            rangemode: 'tozero',
            fixedrange: true,
            tickfont: {
              size: 10,
            },
              exponentformat:'none'
          },
          legend: {
            orientation: 'h',
            font: {size: 9},
            automargin: true,
          },
          annotations: [
            {
              x: '0.12',
              y: '1.03',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'right',
              yanchor: 'bottom',
              text:
                this.app_data.value_mulitplier['prefix'] +
                ' ' +
                this.app_data.exchange_rate['Currency'].slice(0, 3),
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.4,
              y: -0.5,
              xanchor: 'center',
              yanchor: 'top',
              text: config.CEPII_Source,
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8.5,
                color: 'rgb(150,150,150)',
              },
            },
          ],
        };
      },
    },
    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>
